<template>
  <div class="my-3">
    <CFormInput type="file" @change="emitContent" class="mb-3" />
    已上傳檔案：
    <img style="max-width: 400px" :src="fileName" />
  </div>
</template>
<script>
import useQuestionnaire from '@/composables/useQuestionnaire'
import { ref, onMounted } from '@vue/runtime-core'

export default {
  setup() {
    const { uploadImage } = useQuestionnaire()
    const fileName = ref(null)
    const emitContent = async (e) => {
      if (e) {
        const formData = new FormData()
        formData.append('image', e?.target.files[0])
        const res = await uploadImage(formData)
        if (!res.error) {
          fileName.value = res.ret.image
        }
      }
    }
    onMounted(() => {
      emitContent()
    })
    return {
      emitContent,
      fileName,
    }
  },
}
</script>
